import React from 'react';
import { Input } from 'antd';
import StrongTag from '../StrongTag/StrongTag';
import './styles.less';

const SearchBar = ( { searchText, placeHolerText = 'Search by name or id', 
    handleSearchCallback, filterItems, size = 'large', showTags = true, disabled = false,
    closeTagCallback } ) => { 

    return (
        <div className="search-bar">
            <div className="top-row">

                { /* Search Input */ }
                <Input.Search
                    allowClear
                    defaultValue={ searchText }
                    enterButton
                    disabled={ disabled }
                    onSearch={ handleSearchCallback }
                    placeholder={ placeHolerText }
                    size={ size }
                />
            </div>
            
            { /* Tags */ }
            { showTags &&
                <div className="bottom-row">
                    { searchText && 
                        <StrongTag
                            tagKey="searchText"
                            strontText="Search: "
                            text={ searchText }
                            onCloseCallback={ () => {
                                    document.getElementsByClassName( 'ant-tag-close-icon' )[ 0 ].click();
                                    document.getElementsByClassName( 'ant-input-clear-icon' )[ 0 ].click();
                                    if ( closeTagCallback ) {
                                        closeTagCallback();
                                    }
                                }
                            }
                        />    
                    }   
            
                    {  
                        filterItems?.map( i => {
                            return (
                                <StrongTag
                                    key={ i.key }
                                    strontText={ `${ i.title }: ` }
                                    text={ i.name }
                                    onCloseCallback={ i.onClickCallback }
                                />     
                            );
                        } )
                    }          
                </div>
            }
        </div>
    );
};

export const renderWithSearchWords = ( source, searchWords ) => {
    if ( searchWords.length === 0 ) {
        return <span>{ source }</span>;
    }

    const words = source.split( ' ' );
        
    const result = words.map( ( i, index ) => { 
        const found =  searchWords.find( word => i.toLowerCase() === word.toLowerCase() );

        if ( found ) {
            return <span key={ index } className="yellow">{ i } </span>;
        } else {
            return <span key={ index }>{ i } </span>;
        }
    } );

    return <span>{ result }</span>;
};

export default SearchBar;
